import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Chip from "@mui/material/Chip";
import logo from "./img/logo.gif";
import "photoswipe/dist/photoswipe.css";
import "./website.css";
import { Card, CardContent } from "@mui/material";

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {"Copyright © "}
      <Link color="inherit">Castle Pixel</Link> {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const GameButton = ({ url, backgroundColor, label }) => (
  <a href={url} target="_blank" style={{ float: "right" }}>
    <Button
      style={{
        float: "left",
        backgroundColor: backgroundColor,
        marginRight: "5px",
      }}
      variant="contained"
    >
      {label}
    </Button>
  </a>
);

const TruncatedText = ({ text, maxLength }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text || text.length <= maxLength) {
    return (
      <Typography variant="body1" color="text.secondary">
        {text}
      </Typography>
    );
  }

  const displayedText = expanded ? text : `${text.substring(0, maxLength)}...`;

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <div>
      <Typography variant="body1" color="text.secondary">
        {displayedText}
      </Typography>
      <Button onClick={toggleExpanded} size="small">
        {expanded ? "Read Less" : "Read More"}
      </Button>
    </div>
  );
};
const GameSection = ({ title, videoUrl, buttons, description }) => (
  <Grid item xl={12} md={12} xs={12}>
    <h1 style={{ fontSize: "24px", color: "#939393" }}>{title}</h1>
    <div className="embed-container">
      <iframe
        width="560"
        height="315"
        src={videoUrl}
        title={`${title} video player`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="body1" color="text.secondary" align="left">
          {description}
        </Typography>
      </CardContent>
    </Card>
    <div style={{ marginTop: "5px" }}>
      {buttons.map((button, index) => (
        <GameButton key={index} {...button} />
      ))}
    </div>
  </Grid>
);

const SocialChip = ({ url, backgroundColor, label, className }) => (
  <a href={url} target="_blank" className={className}>
    <Chip
      style={{
        color: "white",
        backgroundColor: backgroundColor,
        marginRight: "5px",
        marginLeft: "5px",
      }}
      label={label}
    />
  </a>
);

export default function Website() {
  const games = [
    {
      title: "Cattle Country",
      videoUrl: "https://www.youtube.com/embed/-GV3QQnqGZo?si=NCHOurhu2LYgCZLZ",
      buttons: [
        {
          url: "https://store.steampowered.com/app/2818150/Cattle_Country/",
          backgroundColor: "#1c2939",
          label: "Steam",
        },
        {
          url: "https://www.nintendo.com/us/store/products/cattle-country-switch/?srsltid=AfmBOoouFwJhNBlKI16jgJCqP35whf1Z7rcZhl3hItvN2p_uFHFt_K8_",
          backgroundColor: "#e60012",
          label: "Switch",
        },
        {
          url: "https://www.xbox.com/en-us/games/store/cattle-country/9mtkk4h2fvq1",
          backgroundColor: "#107b10",
          label: "Xbox",
        },
        {
          url: "https://store.playstation.com/en-us/concept/10013085/",
          backgroundColor: "#0052cc",
          label: "PS",
        },
      ],
      description:
        "Cattle Country straddles the saddle of cozy wholesome gaming and action-adventure. Serving up hours of the slice-of-life you’d expect on the frontier – including mining, fishing, crafting, and farming – along with deep-rooted Wild West Quests delivering stories of romance, cattle drives, bandits, and robberies.",
    },
    {
      title: "Blossom Tales 2",
      videoUrl: "https://www.youtube.com/embed/SQTcL91TA3Y?si=PIz9XI60rWTT-Qdn",
      buttons: [
        {
          url: "https://apps.apple.com/us/app/crunchyroll-blossom-tales-ii/id6569216617",
          backgroundColor: "#ff6002",
          label: "Crunchyroll",
        },
        {
          url: "https://store.steampowered.com/app/1747830/Blossom_Tales_II_The_Minotaur_Prince/",
          backgroundColor: "#1c2939",
          label: "Steam",
        },
        {
          url: "https://www.nintendo.com/us/store/products/blossom-tales-ii-the-minotaur-prince-switch/",
          backgroundColor: "#e60012",
          label: "Switch",
        },
        {
          url: "https://www.xbox.com/en-US/games/store/blossom-tales-ii-the-minotaur-prince/9ph9b8q0wmnt",
          backgroundColor: "#107b10",
          label: "Xbox",
        },
      ],
      description:
        "Blossom Tales II: The Minotaur Prince is a charming action-adventure game in the spirit of classic top-down Zelda games. Embark on a grand quest with Lily and her brother Chrys to save the kingdom from the Minotaur King's dark magic.",
    },
    {
      title: "Blossom Tales 1",
      videoUrl: "https://www.youtube.com/embed/-W_JXUJ20og?si=-6ITrqGyocMhmQ-a",
      buttons: [
        {
          url: "https://store.steampowered.com/app/446810/Blossom_Tales_The_Sleeping_King/",
          backgroundColor: "#1c2939",
          label: "Steam",
        },
        {
          url: "https://www.nintendo.com/us/store/products/blossom-tales-the-sleeping-king-switch/",
          backgroundColor: "#e60012",
          label: "Switch",
        },
      ],
      description:
        "Blossom Tales: The Sleeping King is a delightful action-adventure that tells the story of Lily, a brave knight of the Blossom Kingdom. When the King falls into a deep sleep due to a sorcerer's curse, Lily must set out on a perilous journey to find the ingredients for an antidote.",
    },
    {
      title: "Rex Rocket",
      videoUrl: "https://www.youtube.com/embed/wE6R0qnEckI?si=LHk1dYMnYrFsJXmf",
      buttons: [
        {
          url: "https://store.steampowered.com/app/288020/Rex_Rocket/",
          backgroundColor: "#1c2939",
          label: "Steam",
        },
        {
          url: "https://www.xbox.com/en-US/games/store/rex-rocket/9PBF1CZQ2156",
          backgroundColor: "#107b10",
          label: "Xbox",
        },
      ],
      description:
        "Rex Rocket is an old-school 2D platformer inspired by the classics. Blast through challenging levels filled with traps, enemies, and secrets as you try to stop the nefarious plans of a mad AI Hologram!",
    },
  ];

  const socialLinks = [
    {
      url: "https://bsky.app/profile/castlepixel.bsky.social",
      backgroundColor: "#00adee",
      label: "Bluesky",
      className: "orangeF",
    },
    {
      url: "http://twitter.com/CastlePixel",
      backgroundColor: "#179cf0",
      label: "Twitter",
      className: "purpleF",
    },
    {
      url: "https://www.facebook.com/castlepixel",
      backgroundColor: "#0863f7",
      label: "Facebook",
      className: "orangeF",
    },
    {
      url: "mailto:hello@castlepixel.com",
      backgroundColor: "lightGray",
      label: "Email",
      className: "redF",
    },
  ];

  return (
    <div className="App">
      <main className="main-container">
        {/* Hero unit */}
        <Box
          sx={{
            pt: 8,
            pb: 6,
          }}
        >
          <Container maxWidth="xl" align="center">
            <img
              style={{ marginBottom: "20px", maxWidth: "924px" }}
              className="logo"
              src={logo}
              width="100%"
              alt="Castle Pixel Logo"
            />
            <Typography
              variant="h5"
              align="center"
              color="text.secondary"
              paragraph
            >
              Making retro games since 2014
            </Typography>
          </Container>
        </Box>

        <Container>
          <Grid container spacing={10}>
            {games.map((game, index) => (
              <GameSection key={index} {...game} />
            ))}
          </Grid>
        </Container>
      </main>
      {/* Footer */}
      <Box sx={{ bgcolor: "background.paper", p: 6 }} component="footer">
        <Typography
          variant="subtitle1"
          align="center"
          color="text.secondary"
          component="p"
        >
          <div style={{ marginBottom: "15px", marginTop: "75px" }}>
            {socialLinks.map((social, index) => (
              <SocialChip key={index} {...social} />
            ))}
          </div>
        </Typography>
        <Copyright />
      </Box>
      {/* End footer */}
    </div>
  );
}
